
export enum LockType {
  LINK = 'link',
  FILE = 'file',
}

export interface LockConfig {
  tip?: {
    enabled: boolean;
    amount: number; // In cents or simple unit
    currency?: string;
  };
  fomo?: {
    enabled: boolean;
    type: 'timer' | 'limit';
    text: string; // Custom text (e.g. "85/100 claimed" or "Ends in 2h")
    message?: string; // Deprecated/Fallback
    endDate?: number; // Timestamp for timer
  };
  security?: {
    b2bOnly: boolean; // Reject gmail, yahoo, etc.
  };
  preview?: {
    blurStrength: 'none' | 'low' | 'high'; // Magic Preview
  };
  files?: {
    count: number;
    isFolder: boolean;
  };
}

export interface Lock {
  id: string;
  slug: string;
  targetUrl: string; // The destination URL or "file URL"
  type: LockType;
  title: string;
  imageUrl: string; // Background/Preview image
  buttonText: string;
  socialUrl?: string; // The URL of the post/profile to engage with
  socialType?: 'profile' | 'post'; // Derived from socialUrl format (PROFILE: prefix)
  config?: LockConfig; // New flexible config column
  viewsCount: number;
  leadsCount: number;
  createdAt: number;
}

export interface Lead {
  id: string;
  lockId: string;
  email: string;
  createdAt: number;
  deviceType: 'mobile' | 'desktop';
  lockTitle?: string; // Optional title for dashboard display
}

export interface CreateLockDTO {
  targetUrl: string;
  type: LockType;
  title: string;
  imageUrl?: string;
  buttonText?: string;
  socialUrl?: string;
  socialType?: 'profile' | 'post';
  config?: LockConfig;
}